// Which product this is.
//
// The same software is sold under more than one name, and those names are not meant to lead to each
// other: a customer of one has no business learning that the other exists. That rules out keeping
// the list of them here - this file is in the bundle every address serves, so a name written in it
// is a name anybody can read.
//
// So the server tells each address about itself, in a small script the page loads before this one
// (/brand.js), and this reads what it was handed. Nothing names a second product anywhere a browser
// can reach. The fallback is the product's own identity, for a development machine with no server
// in front of it.
//
// A customer's own branding is a different thing again, set by them, and still wins wherever it is
// set: that one says whose yard this is, this one says whose software it is.

// Deliberately nameless. This object is in the file every address serves, so a product named here
// is a product that anybody can read about - which is the thing this whole arrangement exists to
// prevent. The real identity arrives from the server; this is only what a development machine with
// nothing in front of it falls back to.
export const DEFAULT_BRAND = {
  key: 'default',
  name: 'Operations',
  wordmark: 'OPERATIONS',
  developer: '',
  developerUrl: '',
  // Null means the mark and icons the page already ships with.
  developerLogo: null,
  mark: null,
  // A picture of the product's name, when the product has one.
  wordmarkImage: null,
  // Or the name drawn in type and animated once, which costs nothing to fetch.
  animatedWordmark: false,
  // What the product does, in a few words, under its name.
  tagline: '',
  // The end of the wordmark drawn in a colour of its own, and that colour. Null means the whole
  // name is set in one ink, which is what every product did until one of them wanted two.
  wordmarkAccent: null,
  wordmarkAccentColor: null,
  // What the assistant is called - the thing that writes the morning briefing and answers questions
  // typed at it. The platform's own name, shared by every product sold off this deployment, so
  // unlike the wordmark it is safe to ship in the page. It still arrives from the server, because
  // that is the seam to change on the day a partner wants their own name for it.
  assistant: 'ZENY',
  // The brand's own letterforms, as SVG outlines, when it signs itself with its name.
  wordmarkPaths: null,
  // What the product does, shown one capability at a time under the name.
  capabilities: null,
  // The drawing that goes with each of them, as geometry rather than files.
  marks: null,
  favicon: null,
  touchIcon: null,
};

export const brandFrom = (given) => {
  if (!given || typeof given !== 'object' || !given.name) return DEFAULT_BRAND;
  return { ...DEFAULT_BRAND, ...given };
};

// eslint-disable-next-line no-underscore-dangle
const served = typeof window === 'undefined' ? null : window.__BRAND__;
const brand = brandFrom(served);

export default brand;
